import React from "react";
import {
  FaTruck,
  FaUtensils,
  FaConciergeBell,
  FaShoppingBag,
} from "react-icons/fa";

const orderingOptions = [
  {
    value: "pickup",
    label: "Pickup",
    sub: "Collect your order in person",
    icon: <FaShoppingBag className="text-xl" />,
  },
  // {
  //   value: "delivery",
  //   label: "Delivery",
  //   sub: "We’ll bring it to your door",
  //   icon: <FaTruck className="text-xl " />,
  // },
  {
    value: "table",
    label: "Table Reservation",
    sub: "Book a table at our venue",
    icon: <FaUtensils className="text-xl " />,
  },
  {
    value: "table-preorder",
    label: "Table + Pre-order",
    sub: "Reserve & pre-order food",
    icon: <FaConciergeBell className="text-xl" />,
  },
];

const OrderingMethodSelector = ({ selected, onChange }) => {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-text">
        How would you like to order?
      </h2>
      <div className="space-y-4">
        {orderingOptions.map((option) => (
          <div
            key={option.value}
            onClick={() => onChange?.(option.value)}
            className={`cursor-pointer border rounded-xl px-4 py-3 flex items-start space-x-4 transition ${
              selected === option.value
                ? "border-border bg-redlight"
                : "border-border hover:border-gray-400"
            }`}
          >
            <div className="pt-1">{option.icon}</div>
            <div>
              <p className="font-semibold text-text">{option.label}</p>
              <p className="text-gray-500 text-sm">{option.sub}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrderingMethodSelector;
